import React from "react";
import {Switch, Route, Redirect} from "react-router-dom";
import ReactGA from "react-ga";

import {LandingPage} from "./Scroll/LandingPage";
import {GalleryPage} from "./Gallery/GalleryPage";
//import {UserRedirect} from "./Common/UserRedirect";

class App extends React.Component {

    componentWillMount() {
        // Tracking
        // UA-110530764-1 - development (for testing - no filter)
        // UA-110218419-1 - wilson ng photography (actual)

        ReactGA.initialize("UA-110218419-1", {debug: false, titleCase: false});

        let params = window.location.search;
        if (params) {
            params = params.toLowerCase();
        }
        ReactGA.pageview("u-Entered: " + window.location.pathname.toLowerCase() + params);
    }

    render() {
        return (
            <app>
                <Switch>
                    <Route exact path="/" component={LandingPage} />
                    <Route exact path="/Gallery/Landscape" component={GalleryPage} />
                    <Route exact path="/Gallery/Landscape/:name" component={GalleryPage} />
                    <Route exact path="/:name" component={LandingPage} />
                    <Redirect to={{pathname: "/"}}/>
                </Switch>
            </app>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/widgets/App.js